import { render, staticRenderFns } from "./BiDonutChart.vue?vue&type=template&id=af59defa"
import script from "./BiDonutChart.vue?vue&type=script&lang=js"
export * from "./BiDonutChart.vue?vue&type=script&lang=js"
import style0 from "./BiDonutChart.vue?vue&type=style&index=0&id=af59defa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports